import { FC,useState } from "react"

// import Modal from "../modal";
import { StatisticsObjectType } from "./types";

const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  // const [showingModal, setModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [title, setTitle] = useState("");

  return (
    <div className={"d-flex flex-column flex-fill"} style={{maxHeight:550}}>

        {/* {showingModal ? <Modal title={title} data={title === "New Practices" ? StatisticsObjectType.new_practices.data : StatisticsObjectType.new_doctors.data} onClick={() => setModal(false)}></Modal> : null} */}
        <div className="card p-0 mb-3 flex-fill">
            <div className="card-header text-center">
                <h4 className="mt-2 mb-0">Total Cases</h4>
            </div>
            <div className="card-body text-center">
                <h1 className="mt-2 mb-0 fw-bold">{StatisticsObjectType?.received_cases}</h1>
            </div>
        </div>

        <div className="card p-0 mb-3 flex-fill">
            <div className="card-header text-center">
                <h4 className="mt-2 mb-0">New Practices</h4>
            </div>
            <div className="card-body text-center">
                <h1 className="mt-2 mb-0 fw-bold">{StatisticsObjectType?.new_practices?.count}</h1>
            </div>
        </div>

        <div className="card p-0 flex-fill">
            <div className="card-header text-center">
                <h4 className="mt-2 mb-0">New Doctors</h4>
            </div>
            <div className="card-body text-center">
                <h1 className="mt-2 mb-0 fw-bold">{StatisticsObjectType?.new_doctors?.count}</h1>
            </div>
        </div>

    </div>
  )
}
export default CustomButtonRight;
